<template>
    <div class="box">
        <div class="box-content">
            <table class="table _lined">
                <thead>
                <tr>
                    <th>
                        Name
                    </th>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    <tr v-if="new_tag">
                        <td>
                            <input type="text" v-model="new_tag.name" class="form-control" placeholder="New Tag Name">
                        </td>
                        <td style="width: 30px;">
                        </td>
                        <td @click="createTag()" style="width: 30px;" class="cursor-pointer">
                            <i class="fal fa-save"></i>
                        </td>
                    </tr>
                    <tr v-for="tag in tags" v-if="editing.id !== tag.id">
                        <td>
                            <input type="text" v-model="tag.name" class="form-control _stealth" readonly>
                        </td>
                        <td class="txt-danger cursor-pointer" style="width: 30px;" @click="deleteTag(tag.id)">
                            <i class="fal fa-trash-alt"></i>
                        </td>
                        <td @click="editing = tag" style="width: 30px;" class="cursor-pointer">
                            <i class="fal fa-pencil"></i>
                        </td>
                    </tr>
                    <tr v-else>
                        <td class="w-full">
                            <input type="text" v-model="editing.name" class="form-control">
                        </td>
                        <td style="width: 30px;" class="cursor-pointer">
                            <i class="fal fa-times" @click="editing = {}"></i>
                        </td>
                        <td @click="updateTag()" style="width: 30px;" class="cursor-pointer">
                            <i class="fal fa-save"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            'tags': [],
            'new_tag': {},
            'editing': {},
            'loading': true,
            tag_dropdown_open: null,
        };
    },
    mounted() {
        this.loadTags();
    },
    methods: {
        loadTags() {
            axios.get('/downloads/getTags').then((response) => {
                this.tags = response.data;
                this.loading = false;
            });
        },
        updateTag() {
            this.loading = true;
            axios.post('/downloads/updateTag', {
                'id': this.editing.id,
                'name': this.editing.name,
                'sort_order': this.editing.sort_order,
            }).then(() => {
                this.editing = {};
                this.loadTags();
                this.loading = false;
            });
        },
        createTag() {
            this.loading = true;
            axios.post('/downloads/createTag', {
                'name': this.new_tag.name,
                'sort_order': this.new_tag.sort_order,
            }).then(() => {
                this.new_tag = {};
                this.loadTags();
                this.loading = false;
            });
        },
        deleteTag(tag_id) {
            this.loading = true;

            Swal.fire({
                title: 'Are you sure you want to remove this tag?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Confirm',
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('/downloads/deleteTag', {
                        'tag_id': tag_id,
                    }).then((response) => {
                        if(response.data.deleted) {
                            this.loadTags();
                            this.loading = false;
                        } else {
                            Swal.fire({
                                'title': 'Tag not deleted',
                                'icon': 'warning',
                                'html': response.data.message,
                            });
                        }
                    });
                }
            });
        },
        toggleOpenTagDropdown(dropdown_type){
            if (this.tag_dropdown_open === null) {
                this.tag_dropdown_open = dropdown_type;
            } else {
                this.tag_dropdown_open = null;
            }
        },
    },
};
</script>
